import { useEffect } from "react";

const useScrollAnimation = (selector) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    const handleScroll = () => {
      elements.forEach((el) => {
        const elTop = el.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (elTop < windowHeight - 50) {
          el.classList.add("visible");
        }
      });
    };

    
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [selector]); 
};

export default useScrollAnimation;